import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from "../../../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../../../Navigation/Menu";
import VipTablesRequests from "../VipTablesRequests";
import { Grid, EstadoCellRenderer } from "../../../../../Layout/Grid/GridView";
import "../VipTables.css";
import VipTablesTabs from "../VipTablesTabs";
import FormDetailsPayment from "./FormDetailsPayment";
import { Puff } from "react-loading-icons";
import Table from "../../../../../Layout/Table/Table";
import FormPaymentWithdrawal from "./FormPaymentWithdrawal";
import NavBar from "../../../../../../components/NavBar";
import TermsConditionsVipTables from "./../TermsConditions/TermsConditionsVipTables";

const VipTablesPaymentsDetails = () => {
  let params = useParams();
  const gridRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    transactions: [],
    balance: [],
    modalPaymentWithdrawal: {
      show: false,
    },
    terms_condition_readed: false,
  });

  const getTransactionsList = async () => {
    setIsLoading(true);
    let info = await VipTablesRequests.getTableTransactionsList(params);
    if (info && info.status) {
      setState({
        ...state,
        balance: info.data.balance,
        transactions: info.data.transactions,
        modalPaymentWithdrawal: {
          ...state.modalPaymentWithdrawal,
          show: false,
        },
        terms_condition_readed: info.data.terms_condition_readed,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTransactionsList();
  }, []);

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A carregar saldo...</div>
    </div>
  );

  const HeaderCards = () => {
    return (
      <div className="row g-4 mb-5">
        <div className="col-12 col-md-6">
          <div className="campaign-card glass-glow border-0 p-4 d-flex align-items-center" style={{ background: 'rgba(10, 194, 130, 0.05)' }}>
            <div className="icon-box-premium me-4" style={{ color: '#10c282' }}>
              <i className="fa-solid fa-euro-sign"></i>
            </div>
            <div>
              <div className="fs-1 fw-800 text-white mb-0 text-glow">{state.balance.balance_total}€</div>
              <div className="text-muted small text-uppercase ls-1 fw-bold">Saldo Disponível</div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="campaign-card glass-glow border-0 p-4 d-flex align-items-center" style={{ background: 'rgba(1, 169, 172, 0.05)' }}>
            <div className="icon-box-premium me-4" style={{ color: '#01a9ac' }}>
              <i className="fa-solid fa-shuffle"></i>
            </div>
            <div>
              <div className="fs-1 fw-800 text-white mb-0 text-glow">{state.balance.balance_hold}€</div>
              <div className="text-muted small text-uppercase ls-1 fw-bold">Em Processamento</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const TableTransactions = () => {
    return (
      <div className="campaign-card border-0 p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.02)' }}>
        <Grid
          ref={gridRef}
          rows={state.transactions}
          cols={[
            { hide: true, field: "id" },
            { headerName: "Data Pedido", field: "date_request", filter: true },
            { headerName: "Data Processamento", field: "date_start_process", filter: true },
            { headerName: "Data Pagamento", field: "date_payment", filter: true },
            { headerName: "Valor (€)", cellStyle: { textAlign: "right", fontWeight: '700' }, field: "value", filter: 'agNumberColumnFilter' },
            { headerName: "IBAN Pagamento", field: "iban_payment", filter: true },
            {
              headerName: "Estado",
              field: "status",
              cellRenderer: EstadoCellRenderer,
              width: 150
            },
          ]}
          height="55vh"
        />
      </div>
    );
  };

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb premium-breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/my/nightspots">Nightspots</Link>
            </li>
            <li className="breadcrumb-item active">Saldo e Movimentos</li>
          </ol>
        </nav>

        <VipTablesTabs tab="payments" />

        {isLoading ? (
          <InsideLoading />
        ) : (
          <>
            <HeaderCards />

            <div className="row g-4 align-items-center mb-4">
              <div className="col-12 col-md-8">
                <h2 className="campaigns-section-title fs-2 mb-1">Movimentos</h2>
                <p className="campaigns-section-subtitle mb-0">Histórico detalhado de todos os teus levantamentos e transações.</p>
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-md-end">
                <button
                  className="btn-action btn-campaign-primary px-4 rounded-pill w-auto py-2"
                  onClick={() =>
                    setState({
                      ...state,
                      modalPaymentWithdrawal: {
                        ...state.modalPaymentWithdrawal,
                        show: true,
                      },
                    })
                  }
                >
                  <i className="fa-solid fa-arrow-up-from-bracket me-2"></i>
                  Solicitar Levantamento
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <TableTransactions />
              </div>
            </div>

            <FormPaymentWithdrawal
              show={state.modalPaymentWithdrawal.show}
              handleModalhide={() => getTransactionsList()}
            />
            <TermsConditionsVipTables
              show={!state.terms_condition_readed}
              handleModalhide={() => getTransactionsList()}
            />
          </>
        )}
      </div>
    </NavBar>
  );
};

export default VipTablesPaymentsDetails;
